"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import ShopGroupItem from "./components/ShopGroupItem.vue";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import _ from "lodash";
import draggable from "vuedraggable";
let ShopGroupDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.ids = [];
    this.dialog = new UiDialogController();
    this.mode = "view";
    this.loading = false;
    this.groups = null;
    this.selectDatas = [];
    this.edit_status = false;
    this.edit_status_num = 0;
  }
  mounted() {
    return __async(this, null, function* () {
      this.getGroup();
    });
  }
  //打开弹窗
  open() {
    return __async(this, arguments, function* (ids = null, selectDatas = []) {
      this.mode = "view";
      this.edit_status = false;
      if (ids !== null) {
        this.mode = "select";
        this.ids = ids;
        this.selectDatas = selectDatas;
      }
      this.dialog.visible = true;
      yield this.getGroup();
    });
  }
  //关闭弹窗
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
  //更新
  refresh() {
    this.getGroup();
    this.edit_status = false;
  }
  //感知内部状态
  changeMode(mode) {
    if (mode === "edit" || mode === "add") {
      this.edit_status_num += 1;
    } else {
      this.edit_status_num -= 1;
      this.edit_status = false;
    }
    if (this.edit_status_num > 0) {
      this.edit_status = true;
    } else {
      this.edit_status_num = 0;
      this.edit_status = false;
    }
  }
  //获取分组列表
  getGroup() {
    return __async(this, null, function* () {
      try {
        this.loading = true;
        const response = yield API.get(`api://base.auth.pro/v1/groups`, {
          params: {
            "type": "SHOP"
          }
        });
        this.groups = response.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.loading = false;
      }
    });
  }
  //拖拽排序
  checkMove(event) {
    try {
      const _ids = _.map(this.groups, "id");
      API.put(`api://base.auth.pro/v1/groups-sorts`, {
        groupIds: _ids,
        type: "SHOP"
      });
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  //修改店铺所在分组
  saveGroup() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        for (let item of this.selectDatas) {
          if (item !== null && item !== "") {
            arr.push(item);
          }
        }
        yield API.post(`api://base.auth.pro/v1/shops-groups`, {
          shopIds: this.ids,
          groupIds: arr
        });
        this.$message.success(this.$t("shopgroupdialog.saved_successfully"));
        this.$emit("success");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
};
ShopGroupDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      ShopGroupItem,
      draggable
    }
  })
], ShopGroupDialog);
export {
  ShopGroupDialog as default
};
